import axios from "axios";
import {ENDPOINTS} from "../../js/api/_config";

export class HomePageServices{
    static getHomePageData() {
        return axios({
            method: 'GET',
            url: ENDPOINTS.NEW_HOME_PAGE.LANDING_PAGE_DATA,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static getHomeTrainingData() {
        return axios({
            method: 'GET',
            url: ENDPOINTS.NEW_HOME_PAGE.HOME_PAGE_DATA + "upcomingtraining",
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }

    static getCommonCoursesData(data) {
        return axios({
            method: 'POST',
            data: data,
            url: ENDPOINTS.TRAINING_FILTER.GET_PAGE_WISE_TRAINING_DATA,
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e;
        })
    }
}
